import Ajv from "ajv";

import { lvtResponseSchema2 } from "../common";
import { vmsBaseApi } from "../vmsBase";


export const liveUnitDefaultCameraSchema = lvtResponseSchema2({ type: "integer" });

const liveUnitDefaultCameraValidator = new Ajv().compile(liveUnitDefaultCameraSchema);

const extendedApi = vmsBaseApi.injectEndpoints({
    endpoints: (builder) => ({
        getLiveUnitDefaultStreamCameraId: builder.query<number, number>({
            query: (liveUnitId) => ({
                url: `/api/vms/live_units/${liveUnitId}/default_streaming_camera`,
                method: "get",
            }),
            extraOptions: {
                validator: liveUnitDefaultCameraValidator,
            },
        }),
    }),
    overrideExisting: false,
});

export const {
    useGetLiveUnitDefaultStreamCameraIdQuery,
    useLazyGetLiveUnitDefaultStreamCameraIdQuery,
    endpoints: endpointsLiveUnitDefaultCamera,
} = extendedApi;
